import { useDismiss, useFloating, useInteractions, useRole } from "@floating-ui/react";
import { useCallback } from "react";
const useFloatingContext = ({ open, setOpen, breakpointActive }) => useCallback(
  (props) => {
    const floating = useFloating({
      ...props,
      open,
      onOpenChange: setOpen
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
      // useFocus(floating.context, {
      //   enabled: !breakpointActive,
      //   keyboardOnly: true,
      // }),
      useRole(floating.context, { role: "dialog" }),
      useDismiss(floating.context, {
        enabled: !breakpointActive
      })
    ]);
    return {
      ...floating,
      getReferenceProps,
      getFloatingProps
    };
  },
  [open, setOpen, breakpointActive]
);
export {
  useFloatingContext
};
//# sourceMappingURL=useFloatingContext.js.map
